import React, { PureComponent } from 'react'
import SModal from 'components/sModal'
import './styles.css'

export default class EditCoinPopup extends PureComponent {

  render() {
    const { closeModal } = this.props

  	return(
  		<SModal.Main onClose={closeModal} noHead={true} closeOnOutsideClick={true} title='EDIT COIN' >
  			<SModal.Body>
          <fb className="premiumActiveMain">
            <fb className="title">Account Activated</fb>
            <fb className="logoRow icon-poll"></fb>
            <fb className="infoTextBig">The payment was received.</fb>
            <fb className="infoText">
              Your Premium Account is now activated. <br/>
              Enjoy analysing the real time data!
            </fb>
  				</fb>
  			</SModal.Body>
  		</SModal.Main>
  	)
  }
}



// WEBPACK FOOTER //
// ./src/modals/signupModal/premiumActive/index.js